import React from 'react';
import styles from './LoadingST.module.scss';
import { withBasePath } from '@src/common/path-convert';
import { useTranslation } from 'next-i18next';
import { observer } from 'mobx-react-lite';
import { useStores } from '@src/pages/_app';

export const LoadingST = () => {
    const { t } = useTranslation('common');
    const { loadingStore } = useStores();

    // console.log('++++++loadingStore+++++++++++', loadingStore.loading);

    if (!loadingStore.loading) return null;

    return (
        <div className={styles.loadingBG}>
            <div className={styles.loadingST}>
                <img src={withBasePath('/images/newLoading.png')} alt='' loading='lazy' />
                <div className='loadingText'> {t('loading')}</div>
            </div>
        </div>
    );
};

export default observer(LoadingST);
